module.exports = __webpack_public_path__ + "img/modVacio.98671b65.svg";